import { coreServiceUrl } from '../../../config/environment';
import { callApi } from '../../../utils/callApi';
import { ModelDto } from '../core-service.types';

export const getModelByNameApiCall = async (modelName: string): Promise<ModelDto> => {
  const url = `${coreServiceUrl}/wsc/models/by-name?name=${encodeURIComponent(modelName)}`;
  const { data } = await callApi<ModelDto>(url, 'GET');
  return data;
};
